<!-- Пункт бокового меню для раздела планирования. -->
<template>
  <li
    v-if="canSeePage('planning')"
    class="nav-item"
    role="button"
    tabindex="0"
    :class="{ active: activeItem === 'planning' }"
    :title="collapsed ? 'План' : ''"
    @click="navigate($event, 'Planning')"
    @keydown.enter.prevent="navigate($event, 'Planning')"
    @keydown.space.prevent="navigate($event, 'Planning')"
    @mouseup="handleMiddleClick($event, 'Planning')"
    @contextmenu.prevent.stop="showContextMenu($event, 'Planning')"
  >
    <div class="link-icon_box">
      <AppIcon name="planNav" :size="24" />
    </div>
    <AppSidebarItemLabel
      label="План"
      :collapsed="collapsed"
      :show-new-badge="showNewBadge"
    />
  </li>
</template>

<script>
import AppIcon from "@/components/Icon/AppIcon.vue";
import AppSidebarItemLabel from "@/components/AppSidebar/ItemLabel.vue";
import { sidebarItemProps } from "@/composables/useSidebarItem";

export default {
  name: "AppSidebarPlanningItem",

  components: {
    AppIcon,
    AppSidebarItemLabel,
  },

  props: sidebarItemProps,

  emits: ["navigate", "middle-click", "context-menu"],

  methods: {
    navigate(event, routeName) {
      this.$emit("navigate", event, routeName);
    },

    handleMiddleClick(event, routeName) {
      this.$emit("middle-click", event, routeName);
    },

    showContextMenu(event, routeName) {
      this.$emit("context-menu", event, routeName);
    },
  },
};
</script>
